/* eslint-disable react/prop-types */
import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import InformationTooltip from 'modules/core/components/Inputs/InformationTooltip'
import SortableBoxList from 'modules/core/components/SortableBoxList'
import i18n from 'modules/core/lib/i18n'

import type QuestionConfig from 'modules/reviews/store/models/QuestionConfig'
import type Review from 'modules/reviews/store/models/v2/Review'

import Item from './Item'

type ItemProps = React.ComponentProps<typeof Item>

interface Props {
  form: Review
  questionConfigs: QuestionConfig[]
  archived?: boolean
  updateQuestionConfig: ItemProps['updateQuestionConfig']
  createQuestionConfigFromDuplicate: ItemProps['createQuestionConfigFromDuplicate']
  toggleArchivedQuestionConfig: ItemProps['toggleArchivedQuestionConfig']
  reorderQuestionConfig: (config: { id: string; newPosition: number }) => void
  deleteQuestionConfig: ItemProps['deleteQuestionConfig']
  isScore: boolean
}

function List({
  form,
  questionConfigs,
  archived = false,
  updateQuestionConfig,
  createQuestionConfigFromDuplicate,
  toggleArchivedQuestionConfig,
  reorderQuestionConfig,
  deleteQuestionConfig,
  isScore,
}: Props) {
  const items = questionConfigs.sort((a, b) =>
    a.attributes.position > b.attributes.position ? 1 : -1
  )

  const onSortEnd = (items: QuestionConfig[]) => {
    items.forEach((item, index) => {
      reorderQuestionConfig({
        id: item.attributes.id,
        newPosition: index,
      })
    })
  }

  const RenderedItem = ({ item, isScore }: { item: QuestionConfig; isScore: boolean }) => (
    <Item
      key={item.attributes.id}
      form={form}
      questionConfig={item}
      updateQuestionConfig={updateQuestionConfig}
      createQuestionConfigFromDuplicate={createQuestionConfigFromDuplicate}
      toggleArchivedQuestionConfig={toggleArchivedQuestionConfig}
      deleteQuestionConfig={deleteQuestionConfig}
      isScore={isScore}
    />
  )

  return (
    <Box>
      {archived && (
        <Box flexDirection="row" alignItems="center" paddingBottom="s24" gap="s12">
          <Text size="300" weight="medium" color="grey1000">
            {i18n.t('surveys.form.question_configs.archived_list')}
          </Text>
          <InformationTooltip
            information={i18n.t('surveys.form.question_configs.archived_list_tooltip')}
          />
        </Box>
      )}
      <SortableBoxList
        items={items}
        onSortEnd={onSortEnd}
        emptyMessage={i18n.t('surveys.review.questions.question_group_config.no_questions_yet')}
        itemAsKey={(item) => item.attributes.id}
        isDisabled={() => isScore}
        renderItem={(item) => <RenderedItem item={item} isScore={isScore} />}
      />
    </Box>
  )
}

export default observer(List)
